
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';

import FAQ from './FAQ';
import UsePageTracking from '../components/usePageTracking';


function Punetobhimashankarcab() {



    const cardData =
    {
        keyword: 'Pune to Bhimashankar Cab    ',
        heading: 'Morya Cabs:  Pune to Bhimashankar Cab  ',
        headingDescription: 'Looking for a reliable Pune to Bhimashankar Cab service? Morya Cabs offers comfortable, affordable, and well-maintained taxis for your trip to the sacred Bhimashankar Jyotirlinga temple. Whether you are on a spiritual pilgrimage or a nature retreat, our professional drivers guarantee a safe, smooth, and hassle-free journey. Book your Pune to Bhimashankar Cab with Morya Cabs today and enjoy a relaxing ride through the picturesque Western Ghats',

        top: 'Top Places to Visit in Bhimashankar with Morya Cabs',

        topPlaces: [
            {
                "title": "Bhimashankar Temple",
                "description": "One of the 12 Jyotirlingas of Lord Shiva, Bhimashankar Temple is a must-visit pilgrimage site. The temple’s ancient architecture and spiritual significance attract devotees from all over India."
            },
            {
                "title": "Bhimashankar Wildlife Sanctuary",
                "description": "A paradise for nature lovers, this sanctuary is home to diverse flora and fauna, including the rare Indian Giant Squirrel. It offers trekking trails and breathtaking views of the Sahyadri Hills."
            },
            {
                "title": "Hanuman Lake",
                "description": "A serene spot near the temple, Hanuman Lake is perfect for a peaceful retreat. It is an ideal place to relax and enjoy the beauty of nature."
            },
            {
                "title": "Gupt Bhimashankar",
                "description": "A sacred cave located deep in the forests, Gupt Bhimashankar is believed to house a hidden Shivalinga. It is a lesser-known but spiritually significant spot."
            },
            {
                "title": "Nagphani Point (Duke’s Nose)",
                "description": "A popular trekking destination, Nagphani Point offers stunning panoramic views of the surrounding valleys and hills, making it a must-visit for adventure enthusiasts."
            },
            {
                "title": "Sakshi Vinayak Temple",
                "description": "A small but revered temple, Sakshi Vinayak Temple is dedicated to Lord Ganesha. Devotees visit this temple to seek blessings before proceeding to Bhimashankar Temple."
            },
            {
                "title": "Bombay Point",
                "description": "Also known as Mumbai Point, this viewpoint offers a mesmerizing sunset view over the hills and forests of Bhimashankar, making it a favorite among photographers."
            },
            {
                "title": "Ahupe Ghat",
                "description": "A beautiful mountain pass, Ahupe Ghat is an offbeat destination for trekkers and nature lovers. It offers stunning landscapes and lush greenery throughout the year."
            },
            {
                "title": "Peth Fort (Kothaligad)",
                "description": "A historical fort near Bhimashankar, Peth Fort is famous for its unique pinnacle shape and trekking opportunities. The fort provides breathtaking views of the surrounding Sahyadri mountains."
            },
            {
                "title": "Junnar Caves",
                "description": "Located en route to Bhimashankar, the Junnar Caves are ancient Buddhist rock-cut caves with intricate carvings and historical significance. It’s an excellent stopover for history enthusiasts."
            }
        ],



"services": [
    {
        "name": "Pune to Bhimashankar Cab",
        "description": "Morya Cab offers reliable and comfortable cab services from Pune to Bhimashankar. Whether you are planning a spiritual visit to the Bhimashankar Temple or simply exploring the scenic beauty of the area, our cabs provide the ideal way to travel. With professional drivers and well-maintained vehicles, we ensure your trip is smooth and enjoyable."
    },
    {
        "name": "Pune to Bhimashankar Taxi Fare",
        "description": "Morya Cab provides competitive and transparent taxi fares for your journey from Pune to Bhimashankar. We ensure you are aware of the cost upfront, with no hidden charges, making your journey cost-effective and stress-free."
    },
    {
        "name": "Pune to Bhimashankar Cab Fare",
        "description": "Our cab fares for the Pune to Bhimashankar trip are designed to offer the best value for your money. Whether you're traveling solo or with a group, we offer affordable pricing without compromising on comfort and service quality."
    },
    {
        "name": "Taxi from Pune to Bhimashankar",
        "description": "Book a taxi with Morya Cab for your journey from Pune to Bhimashankar. Our experienced drivers know the best routes, ensuring you reach your destination safely and on time. Whether you're traveling for business, leisure, or a religious visit, we ensure a comfortable ride."
    },
    {
        "name": "Pune to Bhimashankar Cab Price",
        "description": "Morya Cab offers the best price for your Pune to Bhimashankar journey, giving you great value without sacrificing comfort. Get an accurate price estimate when you book with us, so you can plan your journey confidently."
    },
    {
        "name": "Book Cab from Pune to Bhimashankar",
        "description": "Booking a cab from Pune to Bhimashankar with Morya Cab is easy and convenient. You can book online or via phone, and our team will confirm your booking to ensure a smooth and timely ride."
    },
    {
        "name": "Pune to Bhimashankar by Cab Charges",
        "description": "We offer transparent and clear charges for your Pune to Bhimashankar cab ride. Morya Cab ensures no hidden fees, so you are always aware of the costs in advance, making it easier to plan your trip."
    },
    {
        "name": "Pune to Bhimashankar Cab Booking",
        "description": "Whether you're looking for a one-way trip or a round trip, booking a cab from Pune to Bhimashankar with Morya Cab is hassle-free. We provide easy booking options, ensuring a comfortable and timely journey to your destination."
    },
    {
        "name": "Pune to Bhimashankar Cab Charges",
        "description": "Morya Cab provides affordable and transparent cab charges for your trip from Pune to Bhimashankar. Our pricing is designed to fit your budget while offering a comfortable and safe ride, so you can enjoy the journey with peace of mind."
    },
    {
        "name": "Pune to Bhimashankar Cab Package",
        "description": "Morya Cab offers customizable cab packages for your trip to Bhimashankar. Whether you need a day trip or a weekend getaway, our packages are designed to fit your schedule and preferences, ensuring a seamless travel experience."
    },
    {
        "name": "Pune to Bhimashankar Car Rental",
        "description": "If you prefer a self-driven car, Morya Cab also offers car rental services for your Pune to Bhimashankar trip. Choose from a variety of vehicles, including sedans, SUVs, and more, to suit your preferences and travel needs."
    },
    {
        "name": "Pune to Bhimashankar Taxi Service",
        "description": "Morya Cab provides reliable taxi services from Pune to Bhimashankar. Whether you’re visiting the temple or exploring the surroundings, our professional drivers and well-maintained taxis ensure a smooth and enjoyable ride."
    },
    {
        "name": "Pune to Bhimashankar Taxi Price",
        "description": "Get affordable and transparent pricing for your Pune to Bhimashankar taxi ride. Our pricing structure is straightforward, ensuring you know the cost of your journey beforehand, so you can plan accordingly."
    },
    {
        "name": "Pune to Bhimashankar Temple Cab Fare",
        "description": "If you're visiting the Bhimashankar Temple, Morya Cab offers specialized taxi services designed for temple trips. Our temple taxi fares are affordable, ensuring you get the best value for a comfortable and safe journey."
    },
    {
        "name": "Pune to Bhimashankar Tempo Traveller",
        "description": "Traveling with a group? Morya Cab provides Tempo Traveller services for larger groups heading from Pune to Bhimashankar. Our spacious Tempo Travellers offer comfort and convenience, making group travel easy and enjoyable."
    },
    {
        "name": "Taxi Service from Pune to Bhimashankar",
        "description": "Morya Cab offers reliable and punctual taxi services from Pune to Bhimashankar. Our drivers are experienced, and our vehicles are well-maintained to ensure a smooth and comfortable ride to your destination."
    },
    {
        "name": "Pune to Bhimashankar Innova Crysta",
        "description": "For a premium travel experience, Morya Cab offers the Innova Crysta for your trip from Pune to Bhimashankar. This luxury vehicle offers ample space and comfort, ensuring a first-class journey for you and your group."
    },
    {
        "name": "Pune to Bhimashankar Tempo Traveller",
        "description": "For larger groups traveling from Pune to Bhimashankar, Morya Cab offers Tempo Traveller services. Our spacious and comfortable vehicles ensure your group enjoys a smooth and pleasant ride to Bhimashankar, with plenty of room for everyone."
    },
    {
        "name": "Contact Information for Pune to Bhimashankar Cab Services",
        "description": "For bookings or more details, contact Morya Cab at +91 9371304510. We offer reliable, comfortable, and affordable taxi services from Pune to Bhimashankar, ensuring a stress-free and enjoyable trip. Book your Pune to Bhimashankar cab today!"
    }
],



tableData: [
    ["Pune to Bhimashankar Cab", "-Pune to Bhimashankar Taxi Fare"],
    ["Pune to Bhimashankar Cab fare", "-Taxi from Pune to Bhimashankar"],
    ["Pune to bhimashankar cab price", "-Book cab from pune to bhimashankar"],
    ["Pune to Bhimashankar by cab charges", "-Pune to bhimashankar cab booking"],
    ["Pune to bhimashankar cab charges", "-Pune to Bhimashankar Cab Package"],
    ["Pune to Bhimashankar car rental", "-Pune to Bhimashankar taxi service"],
    ["Pune to bhimashankar taxi price", "-Pune to bhimashankar temple cab fare"],
    ["Pune to bhimashankar tempo traveller", "-Taxi service from pune to bhimashankar"],
    ["Pune to bhimashankar innova crysta", "-pune to bhimashankar tempo traveller"]
],

whychoose: [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "At Morya Cab, we ensure timely and dependable service for your journey from Pune to Bhimashankar. Whether it’s for a spiritual visit or a relaxing getaway, our drivers will ensure you have a smooth, on-time travel experience."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We provide a range of vehicles, from sedans to SUVs and premium cars, all well-maintained and designed for comfort. Enjoy spacious interiors, air conditioning, and comfortable seating for a pleasant and relaxed ride to Bhimashankar."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are experts in long-distance travel and are well-acquainted with the best routes to Bhimashankar. They ensure a safe, smooth, and comfortable journey, always maintaining the highest standards of professionalism."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Morya Cab offers competitive and transparent pricing. You will receive an upfront, clear breakdown of all charges so that there are no surprises. We ensure affordable rates with no hidden costs, offering you the best value for your money."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our utmost priority. All our vehicles come equipped with modern safety features such as airbags, seat belts, and GPS tracking to ensure that your ride is safe, secure, and comfortable throughout the trip."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Whether you're planning a morning trip or a late-night return from Bhimashankar, Morya Cab is available around the clock to accommodate your schedule. Our customer service team is also available 24/7 to assist with bookings and queries."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking a Pune to Bhimashankar cab is quick and easy with Morya Cab! You can book your ride online via our website, use our mobile app, or get in touch with our customer service team for personalized assistance."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Whether you’re visiting Bhimashankar for spiritual purposes or just for leisure, we offer customized travel packages tailored to your preferences. Let us know your needs, and we’ll create a unique and special trip for you."
    }
]
















    }

    const faqData = [
        {
          question: "How can I book a Pune to Bhimashankar cab with Morya Cab?",
          answer: "Booking is easy! You can book your ride via our website, mobile app, or contact our customer service team for assistance with your booking."
        },
        {
          question: "Are the drivers experienced for long-distance travel?",
          answer: "Yes, all our drivers are experienced in long-distance travel, especially the route from Pune to Bhimashankar, ensuring a safe and smooth journey."
        },
        {
          question: "What types of vehicles are available for Pune to Bhimashankar travel?",
          answer: "We offer a wide variety of vehicles, including sedans, SUVs, and premium cars, all designed to provide comfort and ample space for your journey."
        },
        {
          question: "How do I pay for my Pune to Bhimashankar cab rental?",
          answer: "We accept various payment options, including cash, credit/debit cards, and online payments via our app, making it convenient for you to settle the fare."
        },
        {
          question: "Can I book a round trip from Pune to Bhimashankar?",
          answer: "Yes, round trips can be easily arranged. Provide us with your return details, and we will ensure that your journey to and from Bhimashankar is comfortable and convenient."
        },
        {
          question: "Are there any extra charges for waiting or detours?",
          answer: "Any additional charges, such as for waiting time or detours, will be clearly communicated to you beforehand, ensuring complete transparency in our pricing."
        },
        {
          question: "Can I hire a taxi for sightseeing in Bhimashankar?",
          answer: "Yes, we offer sightseeing tours of Bhimashankar! Explore the famous Bhimashankar Temple and other local attractions with the assistance of our experienced drivers."
        },
        {
          question: "What is the luggage allowance for a Pune to Bhimashankar taxi?",
          answer: "Our vehicles comfortably accommodate standard luggage. If you have additional luggage or special requirements, just let us know during the booking process, and we will make necessary arrangements."
        },
        {
          question: "Is Morya Cab available for corporate travel between Pune and Bhimashankar?",
          answer: "Yes, we offer corporate travel services for business trips, group travel, or any corporate-related visits between Pune and Bhimashankar."
        },
        {
          question: "Why should I choose Morya Cab for my Pune to Bhimashankar trip?",
          answer: "Morya Cab offers a reliable, affordable, and safe journey with experienced drivers, well-maintained vehicles, and excellent customer service, ensuring a smooth and stress-free trip every time."
        }
      ];
      
      const testimonialData = [
        {
          id: 1,
          name: 'Mr. Rajesh Kumar',
          role: 'Traveler',
          review: 'I booked a cab with Morya Cab for a spiritual trip to Bhimashankar. The driver was punctual, the car was clean and comfortable, and the ride was smooth. I felt safe and well taken care of throughout the trip. Highly recommended!',
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        },
        {
          id: 2,
          name: 'Mrs. Anjali Mehta',
          role: 'Family Traveler',
          review: 'Our family had a great experience with Morya Cab during our visit to Bhimashankar. The vehicle was spacious and well-maintained, and the driver was courteous and knowledgeable. We will definitely use their service again.',
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        }
      ];
      
      
      
      
      
      
            
            
            
      











    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9371304510",
            "+91 8379975860",



        ],
        email: "booking@moryacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Shirdi Taxi",
            link: "/Pune-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Bhimashankar Taxi",
            link: "/Pune-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai Taxi",
            link: "/Pune-to-Mumbai-Taxi"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala Taxi",
            link: "/Pune-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mahabaleshwar Taxi",
            link: "/Pune-to-Mahabaleshwar-Taxi"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Aurangabad Taxi",
            link: "/Pune-to-Aurangabad-Taxi"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Nashik-Trimbakeshwar Taxi",
            link: "/Pune-to-Nashik-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Car Rental Services",
            link: "/Pune-Car-Rental-Services"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Ashtavinayak Taxi",
            link: "/Pune-to-Ashtavinayak-Taxi"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Goa Taxi",
            link: "/Pune-to-Goa-Taxi"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Solapur Taxi",
            link: "/Pune-to-Solapur-Taxi"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Hyderabad Cab",
            link: "/Pune-to-Hyderabad-Cab"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Kolhapur Taxi",
            link: "/Pune-to-Kolhapur-Taxi"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Bangalore Taxi",
            link: "/Pune-to-Bangalore-Taxi"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Indore Taxi",
            link: "/Pune-to-Indore-Taxi"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai to Shirdi Taxi",
            link: "/Mumbai-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Borivali to Pune Taxi Service",
            link: "/Borivali-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Vasai to Pune Taxi Service",
            link: "/Vasai-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Dombivli to Pune Taxi Services",
            link: "/Dombivli-to-Pune-Taxi-Services"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Dadar to Shirdi Taxi Service",
            link: "/Dadar-to-Shirdi-Taxi-Service"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Trimbakeshwar Taxi",
            link: "/Mumbai-to-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Bhimashankar Taxi",
            link: "/Mumbai-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai Central to Pune Taxi",
            link: "/Mumbai-Central-to-Pune-Taxi"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Thane to Pune Taxi Service",
            link: "/Thane-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Nashik Taxi",
            link: "/Mumbai-to-Nashik-Taxi"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Lonavala Taxi",
            link: "/Mumbai-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Mumbai Airport to Pune Taxi",
            link: "/Mumbai-Airport-to-Pune-Taxi"
        }
    ];


    const images = [
        { src: "/images/our-fleet/3.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/4.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/5.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/7.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/8.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/10.jpg", alt: "Image 1" },
       
    ];

    
const puneToBhimashankarCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bhimashankar Cab",
  "image": "https://moryacab.com/assets/images/pune-to-bhimashankar-cab.jpg",
  "description": "Book Pune to Bhimashankar cab with Morya Cabs. Choose from AC sedans, SUVs, or tempo travellers. Ideal for Jyotirlinga darshan, round trips & one-way travel. Safe, affordable, and reliable service with verified drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Morya Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "11234",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2999",
    "availability": "https://schema.org/InStock",
    "url": "https://moryacab.com/pune-to-bhimashankar-cab"
  }
};











    return (
        <div>
<UsePageTracking/>
<Helmet>
  <title>Pune to Bhimashankar Cab | AC Sedan, SUV Taxi for Jyotirlinga Darshan</title>
  <meta
    name="description"
    content="Book Pune to Bhimashankar cab with Morya Cabs. Choose from AC sedans, SUVs, or tempo travellers. Ideal for Jyotirlinga darshan, round trips & one-way travel. Safe, affordable, and reliable service with verified drivers."
  />
  <meta
    name="keywords"
    content="Pune to Bhimashankar Cab, Bhimashankar Jyotirlinga Taxi, AC Cab Pune Bhimashankar, Sedan Cab to Bhimashankar, SUV Taxi Bhimashankar Trip, One-Way Cab Pune Bhimashankar, Round Trip Bhimashankar Cab, Morya Cabs Pune to Bhimashankar, Tempo Traveller Bhimashankar, Bhimashankar Darshan Cab Booking, Cab Service to Bhimashankar Temple"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToBhimashankarCabSchema)}
  </script>
</Helmet>
            <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/49.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                               style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Morya Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                                            {Images.map((e) => {
    return (
        <div className="box1" key={e.text}>
            <a
                href={e.link} // Use the separate link for each item
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img src={e.place} alt={e.text} />
                </div>
                <div className="b2">
                    <a href={e.link} className="px-3 colorr">{e.text}</a>
                </div>
            </a>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #0AB4A9',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#0AB4A9' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 9371304510" className="d-block  text-white">+91 9371304510</a>
                                                <a href="tel:+91 8379975860" className="d-block  text-white">+91 8379975860</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@moryacab.com" className=" text-white d-block">
                                                    booking@moryacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Morya Cab<br />
                                                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Punetobhimashankarcab;